'use client';

import { useId } from 'react';

import { cn } from '@/lib/utils';

type Size = 'sm' | 'md' | 'lg';

const SIZES: Record<Size, { mark: string; wordmark: string; gap: string }> = {
  sm: { mark: 'size-5', wordmark: 'text-base', gap: 'gap-3' },
  md: { mark: 'size-6', wordmark: 'text-lg', gap: 'gap-3.5' },
  lg: { mark: 'size-10', wordmark: 'text-3xl', gap: 'gap-4' },
};

export function LogoMark({ className }: { className?: string }) {
  const gradId = useId();
  return (
    <svg
      viewBox="0 0 64 64"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#f81f01" />
          <stop offset="1" stopColor="#ee076e" />
        </linearGradient>
      </defs>
      <rect x="6" y="6" width="22" height="22" rx="5" fill={`url(#${gradId})`} />
      <rect x="36" y="6" width="22" height="22" rx="5" fill={`url(#${gradId})`} opacity="0.78" />
      <rect x="6" y="36" width="22" height="22" rx="5" fill={`url(#${gradId})`} opacity="0.78" />
      <rect x="36" y="36" width="22" height="22" rx="5" fill={`url(#${gradId})`} />
    </svg>
  );
}

export function Logo({
  size = 'md',
  showWordmark = true,
  className,
}: {
  size?: Size;
  showWordmark?: boolean;
  className?: string;
}) {
  const cfg = SIZES[size];
  return (
    <div className={cn('inline-flex items-center', cfg.gap, className)}>
      <LogoMark className={cfg.mark} />
      {showWordmark && (
        <span
          className={cn(
            'text-brand-gradient leading-none font-black tracking-[0.12em] uppercase',
            cfg.wordmark,
          )}
        >
          MESH
        </span>
      )}
    </div>
  );
}
